import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AssessmentRowComponent } from '../assessment-row/assessment-row.component';
import { EmrInputComponent } from "../../../../shared/emr-input/emr-input.component";
import { EmrCheckboxComponent } from "../../../../shared/emr-checkbox/emr-checkbox.component";
import { WnlManagerService } from '../wnl-manager.service';
import { HEENTFormGroup } from 'src/app/calvin-emr-shared/models/assessments/HEENT.model';
import { FormOption } from 'src/app/shared/models/form-option.model';

@Component({
  selector: 'app-heent-form',
  templateUrl: './heent-form.component.html',
  styleUrls: ['./heent-form.component.scss', '../assessments-tab.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    AssessmentRowComponent,
    EmrInputComponent,
    EmrCheckboxComponent
  ],
})
export class HeentFormComponent {

  formGroup = input.required<HEENTFormGroup>();
  wnlManager = new WnlManagerService();

  constructor() {
    this.reset();
  }

  reset() {
    this.wnlManager.setControls(
      [
        // Head
        { control: 'abnormalShape', default: 'WNL', wnl: false },
        { control: 'lesionsOrScars', default: 'WNL', wnl: false },
        // Eyes
        { control: 'pupillaryResponse', default: 'WNL', wnl: false },
        { control: 'leftPupillaryDilation', default: 'WNL', wnl: false },
        { control: 'rightPupillaryDilation', default: 'WNL', wnl: false },
        { control: 'scleraYellow', default: 'WNL', wnl: false },
        { control: 'conjunctivaPale', default: 'WNL', wnl: false },
        { control: 'conjunctivaRed', default: 'WNL', wnl: false },
        // Ears
        { control: 'asymmetrical', default: 'WNL', wnl: false },
        { control: 'hearingImpaired', default: 'WNL', wnl: false },
        { control: 'earDischargePresent', default: 'WNL', wnl: false },
        // Nose
        { control: 'obstructedNares', default: 'WNL', wnl: false },
        { control: 'noseDischargePresent', default: 'WNL', wnl: false },
        // Neck
        { control: 'firmToTouch', default: 'WNL', wnl: false },
        { control: 'stiffNeck', default: 'WNL', wnl: false },
        { control: 'enlargedLymphNodes', default: 'WNL', wnl: false },
        { control: 'deviatedTrachea', default: 'WNL', wnl: false },
        // Throat
        { control: 'dryMucusMembranes', default: 'WNL', wnl: false },
        { control: 'lesionsPresent', default: 'WNL', wnl: false },
        { control: 'enlargedTonsils', default: 'WNL', wnl: false },
      ]
    )
  }

  get abnormalShapeDefault() {
    return this.wnlManager.controlColl['abnormalShape'].default;
  }

  get lesionsOrScarsDefault() {
    return this.wnlManager.controlColl['lesionsOrScars'].default;
  }

  get pupillaryResponseDefault() {
    return this.wnlManager.controlColl['pupillaryResponse'].default;
  }

  get pupillaryDilationDefault() {
    return this.wnlManager.controlColl['leftPupillaryDilation'].default;
  }

  get hearingImpairedDefault() {
    return this.wnlManager.controlColl['hearingImpaired'].default;
  }

  get earDischargePresentDefault() {
    return this.wnlManager.controlColl['earDischargePresent'].default;
  }

  get obstructedNaresDefault() {
    return this.wnlManager.controlColl['obstructedNares'].default;
  }

  get noseDischargePresentDefault() {
    return this.wnlManager.controlColl['noseDischargePresent'].default;
  }

  get firmToTouchDefault() {
    return this.wnlManager.controlColl['firmToTouch'].default;
  }

  get stiffNeckDefault() {
    return this.wnlManager.controlColl['stiffNeck'].default;
  }

  get enlargedLymphNodesDefault() {
    return this.wnlManager.controlColl['enlargedLymphNodes'].default;
  }

  get deviatedTracheaDefault() {
    return this.wnlManager.controlColl['deviatedTrachea'].default;
  }
  get lesionsPresentDefault() {
    return this.wnlManager.controlColl['lesionsPresent'].default;
  }

  get enlargedTonsilsDefault() {
    return this.wnlManager.controlColl['enlargedTonsils'].default;
  }

  pupillaryResponseOptions = [
    new FormOption('Sluggish'),
    new FormOption('Absent'),
    new FormOption('WNL'),
  ];

  pupillaryDilationOptions = [
    new FormOption('2mm'),
    new FormOption('4mm'),
    new FormOption('6mm'),
    new FormOption('8mm'),
  ];
}